<div *ngIf="items" class="menu"
    [class]="(id==10)? 'menu10' : (id==19) ? 'menu19' : (id==37) ? 'menu37' : (id==82) ? 'menu80':''  "
    [ngClass]="{'menu--layout--classic': layout === 'classic', 'menu--layout--topbar': layout === 'topbar'}"
    [hidden]="dropdownOpen==false" #menuElement>
    <div class="row">
        <div class="col-3" *ngFor="let item of items" >
            <a *ngIf="item?.pageURL" [href]="item.pageURL"   (click)="RouteToPage($event, item.pageURL)">
            <ul class="menu__list sub"  (click)="RouteToPage($event, item.pageURL)">
                <li class="menu__item" [ngClass]="{ 'menu__item--hover': item === hoveredItem }"
                    style="text-align: start; margin-left: 25px;" (click)="RouteToPage($event, item.pageURL)">
                    <div style="overflow-x: hidden;">
                        <a *ngIf="item?.pageURL" [href]="item.pageURL" target="_blank" rel="noopener noreferrer"
                           style="border: none; background: rgba(255, 255, 255, 0); color: #ffffff; cursor: pointer !important;"
                           (click)="RouteToPage($event, item.pageURL)">
                            <i class="{{ item.iconClass }}" aria-hidden="true"></i> &nbsp; {{ item.pageCaption }}
                        </a>
                    </div>
                </li>
            </ul>
        </a>
        </div>
        
    </div>
</div>
